import { isRequired, isValidUsername } from "../inputValidations";

const passwordResetInputs = [
  {
    type: "button",
    title: "Reset Password"
  },
  {
    type: "text",
    name: "username",
    label: "Username",
    placeholder: "Enter your username",
    extra: {
      errorMessages: {
        empty: "Please enter your username",
        invalid: "Please create a valid username"
      },
      inputProps: {
        autoCapitalize: "off",
        autoComplete: "username",
        autoCorrect: "off",
        autoFocus: true,
        "data-hj-whitelist": true,
        maxLength: 255,
        minLength: 1,
        spellCheck: false
      }
    },
    validators: [isRequired, isValidUsername]
  }
];

export default passwordResetInputs;
